import EditableRow from './EditableRow'
import styles from './AccountsTable.module.css'

const AccountsTable = ({ editId, savingId, data, handleEdit, handleSave, handleCancel }) => {
  return (
    <table className={styles.table}>
      <thead>
        <tr className={styles.tableHeaderRow}>
          <th className={styles.th}>ID</th>
          <th className={styles.th}>Username</th>
          <th className={styles.th}>Max Students</th>
          <th className={styles.th}>Status</th>
          <th className={styles.th}>Deactivation Date</th>
          <th className={styles.th}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row) =>
          editId === row.id ? (
            <EditableRow
              key={row.id}
              row={row}
              onSave={handleSave}
              onCancel={handleCancel}
              isSaving={savingId === row.id}
            />
          ) : (
            <tr className={styles.tableBodyRow} key={row.id}>
              <td className={styles.td}>{row.id}</td>
              <td className={styles.td}>{row.username}</td>
              <td className={styles.td}>{row.max_student}</td>
              <td className={styles.td}>
                <span
                  className={`${styles.statusPill} ${
                    row.status.toLowerCase() === 'active' ? styles.statusActive : styles.statusInactive
                  }`}
                >
                  {row.status}
                </span>
              </td>
              <td className={styles.td}>{new Date(row.deactivation_date).toLocaleDateString()}</td>
              <td className={styles.td}>
                <button className={styles.editBtn} onClick={() => handleEdit(row.id)} disabled={savingId !== null}>
                  Edit
                </button>
              </td>
            </tr>
          )
        )}
      </tbody>
    </table>
  )
}

export default AccountsTable
